import { Component, OnInit } from '@angular/core';
import { FunctionsService } from "../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../api.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePlanOwnerComponent } from '../change-plan-owner/change-plan-owner.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BreadcrumbService } from 'xng-breadcrumb';
import { UpdateLogoComponent } from '../update-logo/update-logo.component';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { CancelSubscriptionComponent } from '../subscription-details/cancel-subscription/cancel-subscription.component';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';

@Component({
    selector: 'app-account-owner-details',
    templateUrl: './account-owner-details.component.html',
    styleUrls: ['./account-owner-details.component.css'],
    providers: [NgxSpinnerService]
})

export class AccountOwnerDetailsComponent implements OnInit {
    error: any;
    complete = false;
    model = { options: 'M' };
    endDate: any;
   
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    userId:any;
    organization: any = {
        fullAddress: ""
    };
    subscription:any;
    cardInfo:any;
    email:any;
    nextPeriod:any;
    currentDate = new Date();
    remaining_days = 0;
    eDate:any;
    trial_message = "";
    loading = false;
    formProcess = false;
    keep_plan:any;

    constructor(private apiService: ApiService,
        public functionsService:FunctionsService, 
        public router: Router, 
        private modalService: NgbModal,
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private breadcrumbService: BreadcrumbService){
            translate.setDefaultLang('en');
            this.functionsService.setTitle('account.account');
        } 

    ngOnInit(){
        this.trial_message = "";
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
       
        this.breadcrumbService.set('edit-account', 'Edit Company');
        this.spinner.show();
        this.keep_plan = null;
        this.userId = this.functionsService.getUserId();
        this.email = this.functionsService.getEmail();
        this.getOrganizationProfile();
        this.getSubscription();
        this.getPreferredCard();
    }

    getOrganizationProfile(){
        this.apiService.getOrganizationProfile().subscribe(
            data => {
                this.organization = data;
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    getSubscription(){
        this.apiService.getSubscription().subscribe(
            data => {
                this.subscription = data;
                if(this.subscription.cycle == "Y"){
                    this.subscription.cycle = "yearly";
                }else {
                    this.subscription.cycle = "monthly";
                }
                if((this.subscription.nextPeriodId != 0) && !this.subscription.periodTrial){
                    //Get next period
                    this.getNextPeriod(this.subscription.nextPeriodId);
                }
                else { 
                    this.eDate = new Date(this.subscription.periodEndDate);
                    this.endDate = this.subscription.periodEndDate;
                    this.eDate = new Date(this.eDate.getMonth()+1+"/"+this.eDate.getDate()+"/"+this.eDate.getFullYear());
                    this.remaining_days = this.functionsService.remainingDays(this.currentDate,this.eDate);
                }

                if(this.subscription.periodTrial){
                    this.trial_message = this.translate.instant('account.trial_days_left0');
                    if(this.remaining_days>0){
                        this.trial_message = this.translate.instant('account.trial_days_lefta');
                    }
                    this.trial_message = this.trial_message.replace("##DAYS##",this.remaining_days.toString())
                    this.translate.onLangChange.subscribe(() => {
                        this.trial_message = this.translate.instant('account.trial_days_left0');
                        if(this.remaining_days>0){
                            this.trial_message = this.translate.instant('account.trial_days_lefta');
                        }
                        this.trial_message = this.trial_message.replace("##DAYS##",this.remaining_days.toString())
                    })
                }
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    getNextPeriod(periodId){
        this.apiService.getPeriod(periodId).subscribe(
            data => {
                if(data!=null){
                    this.endDate = data["endDate"];
                    this.eDate = new Date(this.endDate);
                    var remaining = this.eDate.getTime() - this.currentDate.getTime(); 
                    this.remaining_days = Math.floor(remaining / (1000 * 3600 * 24));
                    this.remaining_days = this.remaining_days>0?this.remaining_days:0;
                    this.nextPeriod = data;
                    this.translate.onLangChange.subscribe(() => {
                    this.keep_plan = this.translate.instant('account.keep_current_plan');
                    this.keep_plan = this.keep_plan.replace("##DATE##", (this.functionsService.convertUTCDateToLocalDateOnly(this.nextPeriod.startDate)));
                    this.keep_plan = this.keep_plan.replace("##PLAN_NAME##", ((this.nextPeriod.planName)));
                    });

                    this.keep_plan = this.translate.instant('account.keep_current_plan');
                    this.keep_plan = this.keep_plan.replace("##DATE##", (this.functionsService.convertUTCDateToLocalDateOnly(this.nextPeriod.startDate)));
                    this.keep_plan = this.keep_plan.replace("##PLAN_NAME##", ((this.nextPeriod.planName)));
                }
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    getPreferredCard(){
        this.apiService.getPreferredCard().subscribe(
            data => {
                if(data!=null){
                    if(data["cardType"]){
                        switch(data["cardType"]){
                            case "Visa":
                                data["card-fa"] = "fa fa-cc-visa";
                                break;
                            case "MasterCard":
                                data["card-fa"] = "fa fa-cc-mastercard";
                                break;
                            case "Discover":
                                data["card-fa"] = "fa fa-cc-discover";
                                break;
                            case "American Express":
                                data["card-fa"] = "fa fa-cc-amex";
                                break;
                            case "JCB":
                                data["card-fa"] = "fa fa-cc-jcb";
                                break;
                            default:
                                data["card-fa"] = "fa fa-credit-card";
                        }
                    }
                }
                this.cardInfo = data;
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    changePlan() {
        //Get list of available plans
        this.apiService.getPlans().subscribe(
            data => {
                //Pass current selected plan (if any)
                const modalRef = this.modalService.open(ChangePlanOwnerComponent, { size: 'xl' });
            
                modalRef.componentInstance.selectedPlan = this.subscription.subscribedPlanId;
                modalRef.componentInstance.selectedPlanMonthlyPrice = this.subscription.monthlyPrice;
                modalRef.componentInstance.plans = data;
                modalRef.result.then(() => {
                    this.ngOnInit();
                });
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    reactivateSubscription(){
        this.spinner.show();
        var currentDate = new Date();
        var expirationDate = new Date(this.endDate);

        if((currentDate<=expirationDate)){
            this.apiService.reactivateSubscription(this.subscription).subscribe(
                () => {
                    this.spinner.hide();
                    //Modal
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'xl' });
                    var reactivate_subs = this.translate.instant('account.reactivate_subscription_message');
                    reactivate_subs = reactivate_subs.replace("##INVOICE_DATE##", this.functionsService.convertUTCDateToLocalDateOnly(this.endDate));
                    modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                    modalRef.componentInstance.message = reactivate_subs;
                    modalRef.result.then(() => this.ngOnInit());
                },
                error => {
                    this.spinner.hide();
                    this.functionsService.errorHandler(error["status"]);
                }
            );
        }
    }

    cancelSubscription(){
        const modalRef = this.modalService.open(CancelSubscriptionComponent, { size: 'xl' });
        modalRef.componentInstance.subscriptionId = this.subscription.id;
        modalRef.componentInstance.endDate = this.endDate;
        modalRef.result.then(() => this.ngOnInit());
    }

    keepCurrentPlan(){
        var message = this.translate.instant('account.keep_plan_message');

        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('account.keep_plan');
        message = message.replace("##NEW_PLAN##", (this.translate.instant((this.nextPeriod.planName))));
        message = message.replace("##CURRENT_PLAN##", (this.translate.instant((this.subscription.planName))));
        
        confirmModalRef.componentInstance.message = message;
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                this.apiService.keepCurrentPlan().subscribe(
                    () => {
                        this.spinner.hide();
                        this.ngOnInit();
                    },
                    error => {
                        this.spinner.hide();
                        this.functionsService.errorHandler(error["status"]);
                    }
                );
            }            
        });
    }
}